import { initialState as initialStateCombiOpdrachten } from '../../../../opdrachten/combi/services/searchCombiOpdrachten'
import { initialState as initialStateProjecten } from '../../../projecten/services/searchProjecten'
import type { DashboardNavigation } from '../../types/DashboardNavigation'
import type { FetchKpiFilters } from '../../types/FetchKpi'
import type { Kpi } from '../../types/Kpi'

export {
  generateCombiOpdrachtenQuery,
  generateProjectenQuery,
  isProcesstap,
  isKpi,
  isOpdrachtKpi,
}

const isProcesstap = (kpi: Kpi) => !kpi.code
const isKpi = (kpi: Kpi) => !!kpi.code || kpi.statusText === 'Intake'
const isOpdrachtKpi = (kpi: Kpi): kpi is Kpi & { code: string } => !!kpi.code

const generateCombiOpdrachtenQuery = ({
  filters,
  kpi,
  kpiColor,
}: {
  filters: FetchKpiFilters
  kpi: Kpi & { code: string }
  kpiColor?: string
}): DashboardNavigation => {
  const { gebied, netbeheerder, labels, myList } = filters

  return {
    url: '/combiopdrachten',
    query: {
      filters: {
        ...initialStateCombiOpdrachten.query.filters,
        gebied,
        netbeheerder,
        labels,
        werkbak: { code: kpi.code, label: kpi.statusText },
        myList,
        kpi: kpiColor ?? '',
      },
      page: initialStateCombiOpdrachten.query.page,
      sort: initialStateCombiOpdrachten.query.sort,
    },
  }
}

const generateProjectenQuery = ({
  filters,
  kpi,
  kpiColor,
}: {
  filters: FetchKpiFilters
  kpi: Kpi
  kpiColor?: string
}): DashboardNavigation => {
  const { gebied, netbeheerder, labels, myList } = filters

  return {
    url: '/aansluiting/projecten',
    query: {
      filters: {
        ...initialStateProjecten.query.filters,
        netbeheerder,
        gebied,
        labels,
        myList,
        processtap: [kpi.statusText],
        kpi: kpiColor ?? '',
      },
      page: initialStateProjecten.query.page,
      sort: initialStateProjecten.query.sort,
    },
  }
}
